import { Col, Row } from 'react-bootstrap-5';
import Select from 'react-select';
import React, { useState } from 'react';

interface SubSpecialty {
  value: number;
  label: string;
}

interface CompanySubSpecialty {
  id: number;
  subSpecialtyId: number;
}

export interface SubSpecialtiesProps {
  allSubSpecialties: SubSpecialty[];
  companySubSpecialties: CompanySubSpecialty[];
}

function initialSubSpecialtiesSelected(
  allSubSpecialties: SubSpecialty[],
  companySubSpecialties: CompanySubSpecialty[]
): SubSpecialty[] {
  const selectedSubSpecialtyIds = companySubSpecialties.map((css) => css.subSpecialtyId);
  return allSubSpecialties.filter((ss) => selectedSubSpecialtyIds.includes(ss.value));
}

export default function SubSpecialties({
  allSubSpecialties,
  companySubSpecialties
}: SubSpecialtiesProps) {
  const [selectedSubSpecialties, setSelectedSubSpecialties] = useState<SubSpecialty[]>(() =>
    initialSubSpecialtiesSelected(allSubSpecialties, companySubSpecialties)
  );
  const selectedSubSpecialtyIds = selectedSubSpecialties.map((ss) => ss.value);
  const persistedSubSpecialtyIds = companySubSpecialties.map((css) => css.subSpecialtyId);
  const newSubSpecialtyIds = selectedSubSpecialtyIds.filter(
    (id) => !persistedSubSpecialtyIds.includes(id)
  );

  return (
    <>
      <h5 className="fw-semibold">Sub-Specialties</h5>
      <Row>
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={allSubSpecialties}
            value={selectedSubSpecialties}
            onChange={(value) => setSelectedSubSpecialties(value as SubSpecialty[])}
          />
        </Col>
      </Row>

      {companySubSpecialties.map((companySubSpecialty, index) => {
        const isSelected = selectedSubSpecialtyIds.includes(companySubSpecialty.subSpecialtyId);

        return (
          <React.Fragment key={companySubSpecialty.id}>
            <input
              name={`company[company_sub_specialties_attributes][${index}][id]`}
              type="hidden"
              value={companySubSpecialty.id}
            />
            <input
              name={`company[company_sub_specialties_attributes][${index}][sub_specialty_id]`}
              type="hidden"
              value={companySubSpecialty.subSpecialtyId}
            />
            <input
              name={`company[company_sub_specialties_attributes][${index}][_destroy]`}
              type="hidden"
              value={isSelected ? 'false' : 'true'}
            />
          </React.Fragment>
        );
      })}

      {newSubSpecialtyIds.map((subSpecialtyId, i) => {
        const index = i + companySubSpecialties.length;

        return (
          <React.Fragment key={subSpecialtyId}>
            <input
              name={`company[company_sub_specialties_attributes][${index}][sub_specialty_id]`}
              type="hidden"
              value={subSpecialtyId}
            />
          </React.Fragment>
        );
      })}
    </>
  );
}
